<div
  (click)="closeAllDropdowns()"
  class="mb-4 flex flex-col gap-4 rounded-xl border border-gray-200 bg-white p-6 filters-shadow">
  <div class="flex flex-col gap-5 border-b border-gray-200 pb-6">
    <div class="relative z-20 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4" (click)="$event.stopPropagation()">
      <!-- Pharmacy Autocomplete -->
      <app-pharmacy-auto-complete
        class="col-span-2"
        [label]="pharmacyLabel()"
        [placeholder]="pharmacyPlaceholder()"
        [noResultsText]="noPharmacyResults()"
        [clear]="pharmacyClear()"
        (itemSelected)="onPharmacySelected($event)"></app-pharmacy-auto-complete>

      <!-- Payment Method -->
      <div class="w-full">
        <app-filter-multi-select
          [label]="{ titleAr: 'طريقة الدفع', titleEn: 'Payment Method' }"
          [placeholder]="{ titleAr: 'اختر طريقة الدفع', titleEn: 'Select Payment Method' }"
          [items]="paymentMethodOptions()"
          [(selectedIds)]="selectedPaymentMethodIds"
          [showDropdown]="showPaymentMethodDropdown()"
          (toggleDropdown)="togglePaymentMethodDropdown()"></app-filter-multi-select>
      </div>

      <!-- Status -->
      <div class="w-full">
        <app-filter-multi-select
          [label]="{ titleAr: 'الحالة', titleEn: 'Status' }"
          [placeholder]="{ titleAr: 'اختر الحالة', titleEn: 'Select Status' }"
          [items]="statusOptions()"
          [(selectedIds)]="selectedStatusIds"
          [showDropdown]="showStatusDropdown()"
          (toggleDropdown)="toggleStatusDropdown()"></app-filter-multi-select>
      </div>
    </div>

    <div class="relative z-10 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4" (click)="$event.stopPropagation()">
      <!-- Payment Request ID with Validation -->
      <div class="w-full">
        <app-filter-input
          [label]="isArabic() ? 'رقم طلب الدفع' : 'Payment Request ID'"
          [placeholder]="isArabic() ? 'ادخل رقم طلب الدفع' : 'Enter Payment Request ID'"
          [(value)]="requestId"
          [isInvalid]="requestIdInvalid()"></app-filter-input>

        @if (requestIdInvalid()) {
          <p class="mt-1 text-xs text-red-600">
            {{ requestIdErrorMessage() }}
          </p>
        }
      </div>

      <!-- Created By Autocomplete -->
      <div class="w-full">
        <app-creator-auto-complete
          [label]="creatorLabel()"
          [placeholder]="creatorPlaceholder()"
          [noResultsText]="noCreatorResults()"
          [clear]="creatorClear()"
          (itemSelected)="onCreatorSelected($event)"></app-creator-auto-complete>
      </div>

      <!-- Created On From -->
      <div class="w-full">
        <app-filter-date-component
          [label]="isArabic() ? 'تاريخ الإنشاء (من)' : 'Created On From'"
          [value]="createdOnFrom()"
          (valueChange)="createdOnFrom.set($event)"
          [isInvalid]="createdDateInvalid()"></app-filter-date-component>
        @if (createdDateInvalid()) {
          <p class="mt-1 text-xs text-red-600">
            {{ dateErrorMessage() }}
          </p>
        }
      </div>

      <!-- Created On To -->
      <div class="w-full">
        <app-filter-date-component
          [label]="isArabic() ? 'تاريخ الإنشاء (إلى)' : 'Created On To'"
          [value]="createdOnTo()"
          (valueChange)="createdOnTo.set($event)"
          [isInvalid]="createdDateInvalid()"></app-filter-date-component>
      </div>
    </div>
  </div>

  <!-- Actions & Sorting -->
  <div class="flex flex-wrap items-center justify-between gap-4 pt-2">
    <app-filter-sorting-component
      [orderBy]="filters().orderBy!"
      (orderByChange)="filters().orderBy = $event"
      [orderDir]="filters().orderDir!"
      [sortOptions]="sortOptions()"
      (toggleOrder)="onToggleSortOrder()"></app-filter-sorting-component>

    <div class="flex items-center gap-3">
      <button
        type="button"
        (click)="onResetFilters()"
        class="border-primary text-primary hover-bg-primary-10 cursor-pointer rounded-lg border px-6 py-2 text-sm font-medium transition-colors focus:outline-none">
        <span i18n="@@adminProductsResetButton">Clear</span>
      </button>
      <button
        type="button"
        (click)="onApplyFilters()"
        class="bg-primary hover-bg-primary-hover cursor-pointer rounded-lg px-8 py-2 text-sm font-medium text-white shadow-sm transition-colors focus:outline-none">
        <span>{{ isArabic() ? "تطبيق" : "Apply" }}</span>
      </button>
    </div>
  </div>
</div>
